var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.1593 10.833H23.8318C27.1777 10.833 29.1668 12.8222 29.1668 16.1588V23.8313C29.1668 27.168 27.1777 29.1572 23.841 29.1572H16.1593C12.8227 29.1663 10.8335 27.1772 10.8335 23.8405V16.1588C10.8335 12.8222 12.8227 10.833 16.1593 10.833Z",
    fill: "#162930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2157 21.3566C25.1423 21.1916 25.014 21.0541 24.8398 20.9808C24.7573 20.9441 24.6657 20.9258 24.574 20.9258H15.4165C15.0407 20.9258 14.729 21.2374 14.729 21.6133C14.729 21.9891 15.0407 22.3008 15.4165 22.3008H22.924L21.3932 23.8316C21.1273 24.0974 21.1273 24.5374 21.3932 24.8033C21.5307 24.9408 21.7048 25.0049 21.879 25.0049C22.0532 25.0049 22.2273 24.9408 22.3648 24.8033L25.069 22.0991C25.1332 22.0349 25.179 21.9616 25.2157 21.8791C25.289 21.7049 25.289 21.5216 25.2157 21.3566Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.784 18.6431C14.8573 18.8081 14.9857 18.9456 15.1598 19.0189C15.2423 19.0556 15.3248 19.0739 15.4165 19.0739H24.5832C24.959 19.0739 25.2707 18.7623 25.2707 18.3864C25.2707 18.0106 24.959 17.6989 24.5832 17.6989H17.0757L18.6065 16.1681C18.8723 15.9023 18.8723 15.4623 18.6065 15.1964C18.3407 14.9306 17.9007 14.9306 17.6348 15.1964L14.9307 17.9006C14.8665 17.9648 14.8207 18.0381 14.784 18.1206C14.7107 18.2948 14.7107 18.4781 14.784 18.6431Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/Transaction.21f1e78b.svg";
export { ForwardRef as ReactComponent };